<template>
  <layout-content>
    <form-component v-bind="form_data" />
  </layout-content>
</template>

<script>
  import FormComponent from '@pbx/components/contacts/form';
  import { ContactService } from '@pbx/services/ContactService';
  import { ContactMethodService } from '@pbx/services/ContactMethodService';
  export default {
    components: {
      FormComponent
    },
    data() {
      return {
        form_data: {
          item: null,
          id: null
        }
      };
    },
    created() {
      const id = this.$route.params.id;

      const get_contact_request = ContactService.getItem(id);
      const get_contact_methods_request = ContactMethodService.getAllByContactId(id);

      Promise.all([get_contact_request, get_contact_methods_request])
        .then(res => {
          const [contact, methods] = res;
          this.form_data = { id: id, item: contact, contact_methods: methods };
          this.endLoadingPage();
        })
        .catch(e => this.showPageError(e));
    }
  };
</script>
